import { accounts } from "./accounts";
import { agreements } from "./agreements";
import { award } from "./award";
import { classificationCodes } from "./classificationCodes";
import { feedJobs } from "./feedJobs";
import { form } from "./form";
import { fundingProgramRounds } from "./fundingProgramRounds";
import { fundingPrograms } from "./fundingPrograms";
import { funds } from "./funds";
import { groupRoles } from "./groupRoles";
import { modifications } from "./modifications";
import { organization } from "./organization";
import { person } from "./person";
import { picklists } from "./picklists";
import { project } from "./project";
import { proposal } from "./proposal";
import { researchRoles } from "./researchRoles";
import { s2s } from "./s2s";
import { shell } from "./shell";
import { subaward } from "./subaward";
import { tasks } from "./tasks";
import { tenant } from "./tenant";
import { tenantSettings } from "./tenantSettings";
import { unit } from "./unit";
import { userColumnsPreferences } from "./userColumnsPreferences";
import { users } from "./users";

export const api = {
	awards: award,
	form,
	tasks,
	groupRoles,
	modifications,
	picklists,
	project,
	proposal,
	shell,
	subaward,
	tenant,
	accounts,
	feedJobs,
	person,
	users,
	unit,
	organization,
	fundingPrograms,
	fundingProgramRounds,
	classificationCodes,
	s2s,
	funds,
	tenantSettings,
	researchRoles,
	userColumnsPreferences,
	agreements
};
